<template>
	<component
		v-if="currentComponent"
		:is="currentComponent"
		:params="params"
	/>
	<text v-else-if="isUnknownView()">unknown view: '{{ view }}'</text>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import tabs from '@/variables/tabs';
import ApplicationTab from '@/models/ApplicationTab';
import VIEWS from '@/components/tabViewRegistry';

import OrdersView from '@/views/OrdersView.vue';
import OrderAddView from '@/views/OrderAddView.vue';
import UsersView from '@/views/UsersView.vue';
import UserView from '@/views/UserView.vue';
import VehiclesView from '@/views/VehiclesView.vue';
import VehicleView from '@/views/VehicleView.vue';
import VehicleModelsView from '@/views/VehicleModelsView.vue';
import VehicleModelView from '@/views/VehicleModelView.vue';
import VehicleManufacturersView from '@/views/VehicleManufacturersView.vue';
import VehicleManufacturerView from '@/views/VehicleManufacturerView.vue';
import ItemsView from '@/views/ItemsView.vue';
import ItemView from '@/views/ItemView.vue';
import EmployeesView from '@/views/EmployeesView.vue';
import EmployeeView from '@/views/EmployeeView.vue';
import ServiceJobsView from '@/views/ServiceJobsView.vue';
import ServiceJobView from '@/views/ServiceJobView.vue';
import ServiceJobOperationsView from '@/views/ServiceJobOperationsView.vue';
import ServiceJobOperationView from '@/views/ServiceJobOperationView.vue';
import ServiceJobComponentsView from '@/views/ServiceJobComponentsView.vue';
import ServiceJobComponentView from '@/views/ServiceJobComponentView.vue';
import ServiceJobComponentGroupsView from '@/views/ServiceJobComponentGroupsView.vue';
import ServiceJobComponentGroupView from '@/views/ServiceJobComponentGroupView.vue';
import ServiceJobCategoriesView from '@/views/ServiceJobCategoriesView.vue';
import ServiceJobCategoryView from '@/views/ServiceJobCategoryView.vue';
import ServiceJobGroupsView from '@/views/ServiceJobGroupsView.vue';
import ServiceJobGroupView from '@/views/ServiceJobGroupView.vue';
import CounterpartiesView from '@/views/CounterpartiesView.vue';
import CounterpartyView from '@/views/CounterpartyView.vue';
import ItemsGroupsView from '@/views/ItemsGroupsView.vue';
import ItemsGroupView from '@/views/ItemsGroupView.vue';
import ScheduleView from '@/views/ScheduleView.vue';

@Options({
	components: {
		OrdersView,
		OrderAddView,
		UsersView,
		UserView,
		VehiclesView,
		VehicleView,
		VehicleModelsView,
		VehicleModelView,
		VehicleManufacturersView,
		VehicleManufacturerView,
		ItemsView,
		ItemView,
		EmployeesView,
		EmployeeView,
		ServiceJobsView,
		ServiceJobView,
		ServiceJobOperationsView,
		ServiceJobOperationView,
		ServiceJobComponentsView,
		ServiceJobComponentView,
		ServiceJobComponentGroupsView,
		ServiceJobComponentGroupView,
		ServiceJobCategoriesView,
		ServiceJobCategoryView,
		ServiceJobGroupsView,
		ServiceJobGroupView,
		CounterpartiesView,
		CounterpartyView,
		ItemsGroupsView,
		ItemsGroupView,
		ScheduleView,
	},
	props: {
		view: String,
		params: Array,
	},
})
export default class ApplicationTabItemComponent extends Vue {
	declare view: string;
	declare params: [];

	/** Resolved from current view prop – reactive, so no stale or doubled content. */
	get currentComponent(): object | null {
		const v = this.view;
		if (!v) return null;
		const key = v.toLowerCase();
		return VIEWS[key] ?? null;
	}

	isUnknownView(): boolean {
		for (const tab in tabs) {
			const t = (tabs as Record<string, ApplicationTab>)[tab];
			if (t.view === this.view) return false;
		}
		return true;
	}
}
</script>
